package fr.xibalba.generateurClassesLycee.pages.fichier

import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.forms.Button
import fr.xibalba.generateurClassesLycee.GlobalData
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.overflowY
import org.jetbrains.compose.web.css.padding
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.dom.Input
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.width

@Page
@Composable
fun Nettoyage() {
    if (GlobalData.loadedFichier == null) {
        Box(Modifier.padding(24.px)) {
            Text("Aucun fichier chargé")
        }
        return
    }
    val ctx = rememberPageContext()

    if (GlobalData.loadedFichier!!.errorLines.isEmpty()) {
        Column(Modifier.padding(32.px)) {
            Box(Modifier.padding(4.px)) {
                Text("Aucune erreur détectée dans le fichier.")
            }
            Box(Modifier.padding(4.px)) {
                Text("Un total de ${GlobalData.loadedFichier!!.goodEleves.size} élèves valides ont été chargés.")
            }
            Button({
                ctx.router.navigateTo("/eleves/liste")
            }, Modifier.margin(top = 8.px)) {
                Text("Passer à l'étape suivante")
            }
        }
    } else {
        Column(Modifier.padding(32.px).backgroundColor(Color.rgb(245, 245, 245))) {
            Box(Modifier.padding(bottom = 16.px)) {
                Text("Lignes avec des erreurs : ${GlobalData.loadedFichier!!.errorLines.size}")
            }
            Box(Modifier.padding(bottom = 16.px)) {
                Text("Veuillez corriger les lignes ci-dessous avant de continuer. Si une ligne est vide, elle sera ignorée.")
            }
            val lines = GlobalData.loadedFichier!!.errorLines.associateWith { mutableStateOf(GlobalData.editedFichierContent!![it]) }
            for (lineNumber in lines.keys) {
                Input(InputType.Text, attrs = {
                    value(lines[lineNumber]!!.value)
                    onInput { event ->
                        lines[lineNumber]!!.value = event.value
                    }
                    style {
                        padding(0.px, 8.px, 0.px, 8.px)
                        width(100.percent)
                        overflowY("auto")
                    }
                })
            }
            Box(Modifier.height(24.px))
            Button({
                GlobalData.submitNewPatches(lines.mapValues { it.value.value })
            }) {
                Text("Valider")
            }
        }
    }
}